import { useHistory } from "react-router";
import React, {useState } from 'react';
import Toast from "../Common/Toast";
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave} from "@fortawesome/free-solid-svg-icons";
import API from "../../services/API";
import {toast} from "react-toastify";
import { useParams } from 'react-router-dom';
import NeshanMap from "react-neshan-map-leaflet";


function EditAddress() {
    const [map, setMap] = useState(null)
    const [L , setL] = useState(null);
    const [input,setInput] = useState({
        title : '',
        city_id : 0,
        address :   '',
        postal_code : '',
        contact_name : '',
        province_id : 0,
        contact_number : '',
        has_traffic_plan : 0
        })

    const [provinces , setProvinces] = useState([]);

    const [cities , setCities] = useState([]);
    const [cityName,setCityName] = useState('');
    const [provinceName,setProvinceName] = useState('');
    const [position, setPosition] = useState(map?map.getCenter() : {lat:36.298086 , lng: 59.541320})

    const history = useHistory();
    const params = useParams()
    const onButtonClick = ( ) => {

        const request ={
            id: input.id,
            title : input.title,
            city_id : input.city_id ? input.city_id:cities[0].id,
            contact_name : input.contact_name,
            contact_number : input.contact_number,
            postal_code : input.postal_code,
            address : input.address,
            has_traffic_plan : input.has_traffic_plan,
            is_personal_address : input.is_personal_address,
            lat : position.lat,
            lng : position.lng,

        }
        API.saveAddress(request)
            .then((response) => {
                toast.success(response.user_message);
                setTimeout (() => {
                    history.push('/profile/addresses');
                },1500)
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    const onInputChange = (event) => {

        const inputName = event.target.name;
        const inputValue = event.target.value;
        setInput({ ...input , [inputName]: inputValue});
        if(inputName === 'address' && inputValue.substr(inputValue.length - 1) === ' ') {
            const search =provinceName + ' ' +  cityName + ' ' + inputValue;
            API.searchNeshan(search)
                .then((response) => {
                    if(response.items) {
                        const x = response.items[0].location.x;
                        const y = response.items[0].location.y;
                        //setPosition({lat: y, lng: x})
                        map.panTo(new L.LatLng(y, x));
                    }
                })
                .catch((error) => {

                });
        }

    }
    const onProvinceChange = (event) => {
        const province_id = event.target.value;
        setInput({ ...input , province_id : province_id});
        var index = event.nativeEvent.target.selectedIndex;
        setProvinceName(event.nativeEvent.target[index].text);
        API.cities(province_id)
            .then((response) => {
                setCities(response.results.cities)
            })
    }
    const onCityChange = (event)  =>{

        const inputName = event.target.name;
        let inputValue = event.target.value;
        setInput({ ...input , [inputName]: inputValue});
        var index = event.nativeEvent.target.selectedIndex;
        setCityName(event.nativeEvent.target[index].text);
        API.searchNeshan(event.nativeEvent.target[index].text)
            .then((response) => {
                if(response.items) {
                    const x = response.items[0].location.x;
                    const y = response.items[0].location.y;
                   // setPosition({lat: y, lng: x})
                    map.panTo(new L.LatLng(y, x));
                }
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    return (
        <React.Fragment>

            <Toast/>
            <section className="container-fluid rtl ">
                <div className="row">
                    <div className="col-md-3 px-2">
                        <NavBar/>
                    </div>
                    <div className="col-md-9">
                        <TopMenu/>



                        <div className="text-center my-5 text-secondary">
                            <h2>
                                <strong>افزودن آدرس جدید</strong>
                            </h2>

                        </div>
                        <section className="container rtl  p-3 usual-content ">
                            <div className="row">
                                <div className="form-floating col-md-4 mt-4">
                                    <input type="text"
                                           className="form-control px-5"
                                           id="title" name="title"
                                           placeholder="عنوان آدرس"
                                           value={input.title}
                                           onChange={onInputChange}/>
                                    <label htmlFor="title" className="super-small">عنوان آدرس</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <select className="form-select" id="province_id" name="province_id"
                                            aria-label="Floating label select example"
                                            value={input.province_id}
                                            onChange={onProvinceChange}>
                                        {provinces.map(pr => {
                                            return (
                                                <option value={pr.id} key={pr.id} >
                                                    {pr.title}
                                                </option>
                                            )
                                        })}
                                    </select>
                                    <label htmlFor="province_id" className="super-small">استان</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <select className="form-select" id="city_id" name="city_id"
                                            aria-label="Floating label select example"
                                            value={input.city_id}
                                            onChange={onCityChange}
                                    >
                                        <option value={0} >
                                            انتخاب شهر
                                        </option>
                                        {cities.map(ct => {
                                            return (
                                                <option value={ct.id} key={ct.id}>
                                                    {ct.title}
                                                </option>
                                            )
                                        })}
                                    </select>
                                    <label htmlFor="city_id" className="super-small">شهر</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <input type="text"
                                           className="form-control px-5"
                                           id="contact_name" name="contact_name"
                                           placeholder=" نام مسئول هماهنگی"
                                           value={input.contact_name}
                                           onChange={onInputChange}/>
                                    <label htmlFor="contact_name" className="super-small">نام مسئول هماهنگی</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <input type="tel"
                                           className="form-control px-5"
                                           id="contact_number" name="contact_number"
                                           placeholder=" شماره تماس مسئول هماهنگی"
                                           value={input.contact_number}
                                           onChange={onInputChange}/>
                                    <label htmlFor="contact_number" className="super-small">شماره تماس مسئول هماهنگی</label>
                                </div>
                                <div className="form-floating col-md-4 mt-4">
                                    <input type="tel"
                                           className="form-control px-5"
                                           id="postal_code" name="postal_code"
                                           placeholder=" کد پستی"
                                           value={input.postal_code}
                                           onChange={onInputChange}/>
                                    <label htmlFor="postal_code" className="super-small"> کد پستی</label>
                                </div>
                                <div className="form-floating col-md-8 mt-4">
                                    <textarea type="text"
                                           className="form-control px-5"
                                           id="address" name="address"
                                           placeholder=" آدرس"
                                              value={input.address}
                                           onChange={onInputChange}/>
                                    <label htmlFor="address" className="super-small"> آدرس دقیق</label>
                                </div>

                                <div className="custom-control custom-checkbox col-md-4 mt-4">

                                    <input type="checkbox"
                                           className="custom-control-input" id="has_traffic_plan" name="has_traffic_plan"
                                           placeholder="در محدوده طرح ترافیک"
                                           value = "1"
                                           checked= { input.has_traffic_plan > 0 ? "checked" : '' }
                                           onChange={onInputChange}/>


                                    &nbsp;
                                    <label htmlFor="has_traffic_plan"  className="custom-control-label "> آدرس در محدوده طرح ترافیک است</label>
                                </div>
                                <div className=" col-md-12 mt-4">
                                    <select className='btn super-small-2 btn-secondary change-map-type'
                                            onClick={(val) => {map.setMapType(val.target.value);}}

                                    >

                                        <option value='neshan'>
                                            تغییر نوع نقشه
                                        </option>
                                        <option value='dreamy'>
                                            dreamy
                                        </option>
                                        <option value='dreamy-gold'>
                                            dreamy-gold
                                        </option>
                                        <option value='standard-day'>
                                            standard-day
                                        </option>
                                        <option value='standard-night'>
                                            standard-night
                                        </option>

                                    </select>
                                    {/*<MapContainer
                                        center={center}
                                        zoom={zoom}
                                        scrollWheelZoom={false}
                                        whenCreated={setMap}
                                        className="driver-map px-2 rounded-more"

                                    >
                                        {
                                            mapType === 0 &&
                                            <TileLayer
                                                attribution='&copy; <a href="https://barsepar.com">سامانه بارسپار</a> '
                                                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                                            />
                                        }
                                        {
                                            mapType === 1 &&
                                            <TileLayer
                                                attribution='&copy; <a href="https://barsepar.com">سامانه بارسپار</a> '
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            />
                                        }
                                        <Marker
                                            position={[position.lat.toFixed(4),position.lng.toFixed(4)]}
                                            icon={DefaultIcon}
                                        />
                                    </MapContainer>*/}
                                    <NeshanMap
                                        options={{
                                            key: 'web.1b9521ecbf8f47fe8c1866812d07a969',
                                            maptype: 'neshan' ,
                                            poi: true,
                                            traffic: true,
                                            center: [position.lat.toFixed(4),position.lng.toFixed(4)],
                                            zoom: 13,

                                        }}
                                        style = {{
                                            width : '100% !important'
                                        }
                                        }
                                        onInit={(L, myMap ) => {
                                            setMap(myMap)
                                            setL(L)

                                            let marker = L.marker([position.lat.toFixed(4),position.lng.toFixed(4)])
                                                .addTo(myMap)
                                                .bindPopup('موقعیت انتخاب شده');


                                            API.getAddress(params.id)
                                                .then((response) => {
                                                    const addresses = response.results.addresses;
                                                    setInput({
                                                        ...input,
                                                        id : addresses.id,
                                                        title : addresses.title,
                                                        city_id : addresses.city ? addresses.city.id : 0,
                                                        address :   addresses.address,
                                                        postal_code : addresses.postal_code,
                                                        contact_name : addresses.contact_name,
                                                        province_id : addresses.city? addresses.city.province.id : 0,
                                                        contact_number : addresses.contact_number,
                                                        has_traffic_plan : addresses.has_traffic_plan,
                                                    });
                                                    setCityName(addresses.city ? addresses.city.title : '');
                                                    API.provinces(83)
                                                        .then((response) => {
                                                            setProvinces(response.results.provinces)
                                                        })
                                                    if(addresses.city) {
                                                        API.cities(addresses.city.province.id)
                                                            .then((response) => {
                                                                setCities(response.results.cities)
                                                            })
                                                    }

                                                    setPosition( {
                                                        ...position,
                                                        lat : addresses.lat,
                                                        lng : addresses.lng
                                                    })


                                                    myMap.panTo(new L.LatLng(addresses.lat, addresses.lng));
                                                    marker.setLatLng(new L.LatLng(addresses.lat, addresses.lng))

                                                })


                                            myMap.on('click', function (e) {
                                                setPosition(e.latlng)
                                                marker.setLatLng(e.latlng)
                                            });
                                        }}
                                    />
                                </div>
                                <div className="custom-control custom-checkbox col-md-6 mt-4">
                                    &nbsp;
                                </div>
                                <div className="col-md-6 text-left mt-4">
                                    <button className="btn btn-success w-75 "  onClick={onButtonClick}>
                                        <FontAwesomeIcon icon={faSave}/>
                                        &nbsp;
                                        ثبت اطلاعات
                                    </button>
                                </div>
                            </div>
                        </section>
                    </div>

                </div>

            </section>

        </React.Fragment>


    )
}

export default EditAddress;